import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import CollegePageContainer from "../Container/CollegePageContainer";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Fab from '@material-ui/core/Fab';
import SendIcon from '@material-ui/icons/Send';
import { API } from "../../API";
import moment from "moment";
import { getTeacherProfileName, getValidStartDate, handleLogErrorToSlack } from "../../Helper";
import Modal from "../../Components/Modal/Modal";
import { CKEditor } from "ckeditor4-react";
import { notify } from "react-notify-toast";
import axios from "axios";
import Auth from "../../Auth/Auth";
import FormField from "../../Components/FormField/FormField";
import Spinner from "../../Components/Spinner/Spinner";
import Badge from '@mui/material/Badge';
import "./Inbox.css"

const Inbox = (props) => {
  const [filteredBookings, setFilteredBookings] = useState([])
  const [allBookings, setAllBookings] = useState([]);
  const [selectedBooking, setBooking] = useState({})
  const [sendMaterialPopup, setSendMaterialPopup] = useState(false)
  const [event, setEvent] = useState(undefined)
  const [emailContents, setEmailContents] = useState(null)
  const [fileList, setFileList] = useState(null);
  // const [subject, setSubject] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [isSendingEmail, setIsSendingEmail] = useState(false)

  const role = Auth.verifyUserRole();
  const ref = useRef()
  const fileInputRef = useRef();

  const openSendMaterialPopup = (event) => {
    setSendMaterialPopup(true)
    if (event) {
      setEvent(event)
    }
  }

  const closeSendMaterialPopup = () => {
    setSendMaterialPopup(false)
    setEvent(null)
    setEmailContents("")
    setFileList(null)
    // setSubject("")
  }


  const sendMaterials = () => {
    if (!emailContents) {
      notify.show("Please enter email content")
    } /* else if(!files.length) {
      notify.show("Please upload lesson material")
    } */ else {
      console.log("Inbox")
      setIsSendingEmail(true)
      if(!files.length) {
        return API.addMessageToMaterialConversations(
          props.user.role === "personnel" ? props.user.personnel_id : props.user.customer_id,
          selectedBooking?.materials?.[0]?.receiver_id,
          role !== "teacher" ? "teacher" : "customer",
          "[No-reply]" + getSubject(),
          "<p>You have received the following instructions and attachments relating to your upcoming booking: </p><br />" +
          emailContents + "<p>Please log in to your ReadyTeacher account to reply to this message.</p>",
          [],
          selectedBooking?._id,
          selectedBooking?.materials?.[0]?._id
        ).then((res) => {
          setTimeout(() => {
            window.location.reload(false)
          }, 2000)
          setIsSendingEmail(false)
          setSendMaterialPopup(false);
          notify.show("Lesson email sent successfully")
        }).catch((err) => {
          setIsSendingEmail(false)
          notify.show(err.response.data.error || "Failed to send email")
          console.log(err.response)
        })
      }

      const zip = require('jszip')();
      for (let file = 0; file < files.length; file++) {
        // Zip file with the file name.
        zip.file(files[file].name, files[file]);
      }
      zip.generateAsync({type: "blob"}).then(zipFiles => {
        // Upload zipped files to AWS
        API.uploadFileToS3({
          fileName: `${getSubject()} ${new Date().getTime()}`,
          fileType: "application/zip",
          _id: "materials",
        })
          .then((res) => {
            const returnData = res.data.data.returnData;

            const signedRequest = returnData.signedRequest;
            const url = returnData.url;
            const options = {
              headers: {
                "Content-Type": "application/zip",
              },
            };
            axios
              .put(signedRequest, zipFiles, options)
              .then((res2) => {
                const prefix = "https://platform-backend-files.s3.amazonaws.com/";
                const suffix = url.substring(prefix.length, url.length);
                const new_url = prefix + suffix;

                API.addMessageToMaterialConversations(
                  props.user.role === "personnel" ? props.user.personnel_id : props.user.customer_id,
                  selectedBooking?.materials?.[0]?.receiver_id,
                  role !== "teacher" ? "teacher" : "customer",
                  "[No-reply]" + getSubject(),
                  "<p>You have received the following instructions and attachments relating to your upcoming booking: </p><br />" +
                  emailContents + "<p>Please log in to your ReadyTeacher account to reply to this message.</p>",
                  fileList ? [new_url] : [],
                  selectedBooking?._id,
                  selectedBooking?.materials?.[0]?._id
                ).then((res) => {
                  setTimeout(() => {
                    window.location.reload(false)
                  }, 2000)
                  setIsSendingEmail(false)
                  setSendMaterialPopup(false);
                  notify.show("Lesson email sent successfully")
                }).catch((err) => {
                  setIsSendingEmail(false)
                  notify.show(err.response.data.error || "Failed to send email")
                  console.log(err.response)
                })
              }).catch((error1) => {
              handleLogErrorToSlack(error1, true)
              setIsSendingEmail(false)
              notify.show("Failed to generate material download link")
              console.log(error1);
            });
          })
          .catch((err) => {
            setIsSendingEmail(false)
            console.log(err);
          });
      });
    }
  }

  const files = fileList ? [...fileList] : [];

  const uploadFile = (e) => {
    console.log('Files: ', e.target.files)
    setFileList(e.target.files)
  }

  const removeAttachment = (idx) => {
    files.splice(idx, 1)
    setFileList(files)
    fileInputRef.current.value = files;
  }

  const getConversationTitle = (job) => {
    let title = getTeacherProfileName(job.teacher) + ", " + job.level + (props.campuses.find(campus => campus._id === job.campus_id)
      ? " at " + props.campuses.find(campus => campus._id === job.campus_id).reference_name + " "
      : "")
    if (job.multiple_date && job.booking_date !== job.end_booking_date) {
      title = title + " from " + moment(getValidStartDate(job)).format("DD-MM-YYYY")
        + " to " + moment(job.end_booking_date).format("DD-MM-YYYY")
    } else {
      title  = title + " on " + moment(job.booking_date).format("DD-MM-YYYY")
    }
    return title
  }

  const getSubject = () => {
    let subject = "Follow-up " + props.institution.institution_name + " Lesson plan for your "
    if (event) {
      if (event.multiple_date && event.booking_date !== event.end_booking_date) {
        subject += event.level + " class from " + moment(getValidStartDate(event)).format("DD-MM-YYYY")
          + " to " + moment(event.end_booking_date).format("DD-MM-YYYY")
      } else {
        subject += event.level + " class on " + moment(event.booking_date).format("DD-MM-YYYY")
      }
    }
    return subject
  }

  useEffect(() => {
    setIsLoading(false)
    API.getAllTeachersBrief()
      .then((res) => {
        getAllBookings(res.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  const getAllBookings = (teachers) => {
    API.getCampusBookingsByInstitutionID(props.institution._id)
      .then((result) => {
        let bookings = []
        let list = result.data
        const pathname = window.location.href;
        const urlArray = pathname.split("#");
        const materialId = urlArray[1]?.split("_")[0];
        if (list) {
          list.forEach((booking) => {
            let newMaterial = {...booking};

            booking.materials && booking.materials.forEach((material) => {
              newMaterial.teacher = teachers.find((teacher) => teacher._id === material.receiver_id);
              newMaterial.is_read = isRead(newMaterial)
              let newBooking = {
                ...newMaterial,
                materials: [{...material}]
              }
              if (material._id === materialId) {
                markConversationAsRead(newBooking);
                setBooking(newBooking);
                newBooking.is_read = true;
              }
              bookings.push(newBooking);
            })
          })
        }

        bookings.sort((a, b) => (a?.materials?.[0]?.updatedAt < b?.materials?.[0]?.updatedAt) ? 1 : -1)
        if (bookings.length > 0 && !materialId) {
          setBooking(bookings[0])
          markConversationAsRead(bookings[0])
          bookings[0].is_read = true
        }
        setAllBookings(bookings)
        setFilteredBookings(bookings)
        setTimeout(() => {
          const selectedMessage = document.getElementById(materialId);
          if (selectedMessage) {
            selectedMessage.scrollIntoView({ block: "center" });
          }}, 100)
        setIsLoading(true)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const tabs = [
    {
      text: "My Bookings",
      pathname: "/SendLessonMaterials",
    },
    {
      text: "Inbox",
      pathname: "/Inbox",
      active: true,
    },
  ]

  const editorToolbar = [
    {
      name: "basicstyles",
      groups: ["basicstyles"],
      items: ["Bold", "Italic", "Strike", "Underline", "-", "Cut", "Copy", "Paste", "Undo", "Redo"],
    },
    {
      name: "paragraph",
      groups: ["list"],
      items: ["NumberedList", "BulletedList"],
    },
    {name: "links", items: ["Link", "Unlink"]},
  ];

  const isReceiver = (conversation, booking) => {
    let isReceiver = false
    if (booking) {
      if (booking.teacher?._id === conversation?.sender_id) {
        isReceiver = true
      }
    } else {
      if (selectedBooking?.teacher?._id === conversation?.sender_id) {
        isReceiver = true
      }
    }
    return isReceiver
  }

  const isRead = (booking) => {
    let isRead = booking?.materials?.[0]?.is_read || false
    // console.log(booking)
    const conversations = booking?.materials?.[0]?.conversations || []
    conversations.forEach(c => {
      if (!isReceiver(c, booking) && !c.is_read) {
        isRead = false;
      }
    })
    return isRead
  }

  const markConversationAsRead = (booking) => {
    API.markAConversationAsRead(booking?.materials?.[0]?._id)
      .then()
      .catch(err => {
        console.log(err.response)
      })

    if (filteredBookings.length > 0) {
      let newBookings = filteredBookings.map(b => {
        let updatedBooking = b;
        if (b._id === booking._id) {
          updatedBooking.is_read = true
        }
        return updatedBooking
      })
      // console.log(newBookings)
      setFilteredBookings(newBookings)
    }
  }

  const search = (e) => {
    const keyword = e.target.value.toLowerCase();
    let filteredBookings = allBookings.filter(booking => {
      const title = getConversationTitle(booking)?.toLowerCase();
      return title.includes(keyword)
    })
    setFilteredBookings(filteredBookings)
  }

  useEffect(() => {
    if (ref) {
      ref.current.scrollIntoView();
    }
  }, [ref, selectedBooking])

  return (
    <CollegePageContainer user={props.user} tabs={tabs} header="Send Lesson Materials">
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h5" className="header-message">Chat</Typography>
          </Grid>
        </Grid>
        <Grid container component={Paper} className="chat-section w-100">
          <Grid item xs={4} className="h-100 user-tabs-border">
            <Grid item xs={12} className="search-conversation">
              <TextField
                id="outlined-basic-email"
                label="Search"
                variant="outlined"
                onChange={search}
                fullWidth
              />
            </Grid>
            <Divider/>
            <List className="tab-user">
              {isLoading ?
                (filteredBookings && JSON.stringify(filteredBookings) !== "[]" ?
                  filteredBookings.map(booking => (
                    <ListItem
                      button
                      key={booking?.id}
                      id={booking?.materials?.[0]?._id}
                      selected={booking?.materials?.[0]?._id === selectedBooking?.materials?.[0]?._id}
                      className="conversation-tab"
                      onClick={() => {
                        markConversationAsRead(booking)
                        setBooking(booking)
                    }}>
                      <ListItemIcon>
                        <Badge
                          color="primary"
                          variant={booking.is_read ? "" : "dot"}
                        >
                          <Avatar src={booking?.teacher?.img_url}/>
                        </Badge>
                      </ListItemIcon>
                      <div className="d-flex flex-column justify-content-start">
                        <ListItemText primary={getConversationTitle(booking)}/>
                        {booking?.materials?.[0]?.updatedAt && <ListItemText
                          secondary={`Updated: ${moment(booking?.materials?.[0]?.updatedAt)
                            .format('DD-MM-YYYY, h:mm a')}`}/>}
                      </div>
                    </ListItem>
                  ))
                  : <ListItem>No messages to display</ListItem>)
                : <Spinner small/>}
            </List>
          </Grid>
          <Grid item xs={8} className="h-100">
            <List className="message-area">
              {selectedBooking?.materials?.[0] && <ListItem>
                <Grid container direction="column" alignItems="flex-end">
                  <Grid
                    xs={11}
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    className="message-sender"
                  >
                    <ListItemText primary={
                      <span
                        className="font-weight-bold"
                        dangerouslySetInnerHTML={{
                          __html: selectedBooking?.materials?.[0]?.subject?.replace('[No-reply]', '')
                        }}
                      />
                    }/>
                    <ListItemText primary={
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                          selectedBooking?.materials?.[0]?.content
                        }}
                      />
                    }/>
                    {selectedBooking?.materials?.[0]?.attachments?.[0] && <ListItemText primary={
                      <a
                        href={selectedBooking?.materials?.[0]?.attachments?.[0]}
                        style={{ color: "blue" }}
                      >Attached files
                      </a>}
                    />}
                  </Grid>
                  <Grid item>
                    <div className="conversation-time">
                      {moment(selectedBooking?.materials?.[0]?.createdAt).format('MMMM Do YYYY, h:mm a')}</div>
                  </Grid>
                </Grid>
              </ListItem>}
              {selectedBooking?.materials && selectedBooking?.materials?.[0]?.conversations?.map((conversation) => (
                <ListItem key={conversation._id}>
                  <Grid container direction="column" alignItems={isReceiver(conversation) ? "flex-start" : "flex-end"}>
                    <Grid
                      xs={11}
                      container
                      direction="column"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      className={isReceiver(conversation) ? "message-receiver" : "message-sender"}
                    >
                      <ListItemText primary={
                        <span
                          className="font-weight-bold"
                          dangerouslySetInnerHTML={{
                            __html:
                            conversation?.subject?.replace('[No-reply]', '')
                          }}
                        />
                      }/>
                      <ListItemText primary={
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                            conversation?.content
                          }}
                        />
                      }/>
                      {conversation?.attachments?.[0] && <ListItemText primary={
                        <a
                          href={conversation.attachments[0]}
                          style={{ color: "blue" }}
                        >Attached files
                        </a>}
                      />}
                    </Grid>
                    <Grid item>
                      <div className="conversation-time">
                        {moment(conversation?.updatedAt).format('MMMM Do YYYY, h:mm a')}</div>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
              <div ref={ref}/>
            </List>
            {JSON.stringify(selectedBooking) !== "{}" && (
              <>
                <Divider/>
                <Grid container className="send-field pr-2">
                  <Grid>
                    <Fab
                      className="send-email-icon"
                      size="medium"
                      aria-label="add"
                      onClick={() => openSendMaterialPopup(selectedBooking)}
                    >
                      <SendIcon fontSize="small"/>
                    </Fab>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </div>

      <Modal
        className="w-50"
        header={event ? "Send Email to " + getTeacherProfileName(event.teacher) : "Send Email"}
        onClose={closeSendMaterialPopup}
        show={sendMaterialPopup}
        enforceFocus={false}
      >
        <FormField
          label="Subject"
          id="email-subject"
          type="text"
          // onChange={(e) => setSubject(e.target.value)}
          // value={subject}
          // required
          disabled
          placeholder={getSubject()}
        >
        </FormField>
        <label>Email Contents</label>
        <CKEditor
          config={{toolbar: editorToolbar, removeButtons: 'Subscript, Superscript', versionCheck: false }}
          onChange={({editor}) => setEmailContents(editor.getData())}
          content={emailContents}
          style={{boxShadow: "inset 0 0 0 1px #fff, 1px 1px 2px #1beabd, 1px 1px 8px #10afff"}}
        />
        <div className="form-row py-3">
          <div className="col-sm-auto py-2">
            <button
              type="submit"
              className="btn btn-outline-secondary btn-block"
              onClick={() => document.getElementById("attachments").click()}
              disabled={fileList && fileList?.length > 0}
            >
              Attachments
              <i className="align-middle icon-paper-clip fa fa-paperclip ml-1"/>
              <input
                id="attachments"
                type="file"
                onChange={(e) => uploadFile(e)}
                multiple
                className="d-none"
                ref={fileInputRef}
              />
            </button>
            <ul>
              {files.map((file, i) => (
                <div>
                  <li className="d-inline" key={i}>{file.name}</li>
                  <i
                    className="mdi mdi-delete-circle mt-1 ml-1 uploaded-file-delete-icon"
                    onClick={() => removeAttachment(i)}
                  />
                </div>
              ))}
            </ul>
          </div>
          <div className="col py-2">
            <button
              className="btn btn-primary float-right ml-1"
              onClick={sendMaterials}
              disabled={isSendingEmail}
            >
              Send Email
            </button>
            <div className={isSendingEmail ? "text-right text-secondary pt-1 mr-2" : "d-none"}>Sending...</div>
          </div>
        </div>
      </Modal>
    </CollegePageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    classes: state.college.classes,
    campuses: state.college.campuses,
    college: state.admin.college_details,
  };
}

export default connect(mapStateToProps)(Inbox);